import { type RxCollection, type RxCollectionCreator } from 'rxdb';
import { AppointmentProposalOptionProduct } from '../../../data-access/appointmentProposalOptionProducts';
import {
  identityMigration,
  lwwConflictHandler,
} from '../../rxdb/utils/collectionDefaults';

const productsSchema = {
  version: 6,
  primaryKey: 'appointmentProposalOptionProductId',
  type: 'object',
  properties: {
    appointmentProposalOptionProductId: { type: 'string', maxLength: 36 },
    appointmentProposalOptionId: { type: 'string', maxLength: 36 },
    appointmentProposalId: { type: 'string', maxLength: 36 },
    appointmentId: { type: 'string', maxLength: 36 },
    jobId: { type: 'string' },
    pricebookId: { type: 'string' },
    entityType: { type: 'string' },
    name: { type: 'string' },
    status: { type: 'string' },
    type: { type: 'string' },
    groupingName: { type: 'string' },
    itemGroupName: { type: ['string', 'null'] },
    itemGroupRootId: { type: ['string', 'null'] },
    description: { type: 'string' },
    model: { type: 'string' },
    brand: { type: 'string' },
    price: { type: 'number' },
    defaultPriceType: { type: 'string' },
    currency: { type: 'string' },
    quantity: { type: 'number' },
    sortOrder: { type: 'number' },
    taxable: { type: 'boolean' },
    equipmentTypeIds: { type: 'array' },
    categoryIds: { type: 'array' },
    warranties: { type: 'array' },
    linkedItems: { type: 'array' },
    pricebookPrices: { type: 'array' },
    images: { type: 'array' },
    externalIds: { type: 'array' },
    errorDetail: { type: ['object', 'null'] },
    durationBillingId: { type: ['string', 'null'] },
    syncedAt: {
      type: 'number',
      multipleOf: 1,
      maximum: 9999999999999,
      minimum: 0,
    },
    updatedAt: { type: 'string' },
    createdAt: { type: 'string' },
    offlineSyncErrors: { type: ['object', 'null'] },
  },
  indexes: [
    ['appointmentProposalOptionId'],
    ['appointmentProposalId'],
    ['syncedAt'],
  ],
  required: [
    'appointmentProposalOptionProductId',
    'appointmentProposalOptionId',
    'appointmentProposalId',
    'syncedAt',
  ],
} as const;

export const optionProductsCollections: Record<
  'appointment_proposal_option_products',
  RxCollectionCreator
> = {
  appointment_proposal_option_products: {
    autoMigrate: false,
    schema: productsSchema,
    conflictHandler: lwwConflictHandler,
    migrationStrategies: {
      1: identityMigration,
      2: identityMigration,
      3: identityMigration,
      4: identityMigration,
      5: identityMigration,
      6: identityMigration,
    },
  },
};

export type AppointmentProposalOptionProductDocType =
  AppointmentProposalOptionProduct & {
    syncedAt: number;
  };

export type AppointmentProposalOptionProductsCollections = {
  appointment_proposal_option_products: RxCollection<AppointmentProposalOptionProductDocType>;
};
